import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import DyDLanding from "./views/DyDLanding.vue"
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import Artist from "./views/Artist.vue"
import AboutUs from "./views/Aboutus.vue"
import Video from "./views/Videos.vue"
import Blog from "./views/Blog.vue"
import BlogPost from "./views/BlogPost.vue"

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "DyDLanding",
      components: {
        header: AppHeader,
        default: DyDLanding,
        footer: AppFooter
      }
    },
    {
      path: "/landing",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
	{
	  path: '/videos',
	  name: 'videos',
      components: {
        header: AppHeader,
        default: Video,
        footer: AppFooter
      }
	},
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/profile/:profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      },
	  props: {
		default: true // Pass props to the 'default' named view
	  }
	},
	{
      path: "/artist",
      name: "Artist",
      components: {
        header: AppHeader,
        default: Artist,
        footer: AppFooter
      }
    },
	{
      path: "/about",
      name: "AboutUs",
      components: {
        header: AppHeader,
        default: AboutUs,
        footer: AppFooter
      }
    },
    {
      path: "/blog",
      name: "Blog",
      components: {
        header: AppHeader,
        default: Blog,
        footer: AppFooter
      }
    },
    {
      path: "/blog/:id",
      name: "BlogPost",
      components: {
        header: AppHeader,
        default: BlogPost,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
